/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { Icd10Coding } from "./Icd10Coding";
import type { VisitProgram } from "./VisitProgram";

/**
 * Request schema for closing a Nori conversation at the conclusion of a Curai visit
 */
export interface CloseConversationRequest {
  /** The ID of the Nori conversation */
  conversation_id: string;
  /** Nori user ID of the conversation's patient */
  user_id: string;
  /** Whether the conversation was incomplete */
  incomplete?: boolean;
  /** The care program the visit was created for, sent only alongside an enrollment decision. */
  program?: VisitProgram | null;
  /** Whether the clinician approved the patient's enrollment in the program */
  enrollment_approved?: boolean | null;
  /** The primary ICD-10 code billed for the visit */
  primary_icd10_code?: Icd10Coding | null;
  /** Every other ICD-10 code billed across the visit's child encounters */
  additional_icd10_codes?: Icd10Coding[];
}
